var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoleMapping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.7719C14.0711 17.7719 15.75 16.0929 15.75 14.0219C15.75 11.9508 14.0711 10.2719 12 10.2719C9.92893 10.2719 8.25 11.9508 8.25 14.0219C8.25 16.0929 9.92893 17.7719 12 17.7719Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 11.7719C19.2484 11.7711 20.1098 11.9741 20.891 12.3646C21.6722 12.7551 22.3516 13.3224 22.8751 14.0214",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12476 14.0217C1.64829 13.3226 2.32766 12.7552 3.10888 12.3647C3.89009 11.9741 4.75162 11.7711 5.62502 11.7719",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60327 21.1467C7.09594 20.1347 7.8632 19.2817 8.81746 18.6849C9.77173 18.0882 10.8746 17.7719 12.0001 17.7719C13.1256 17.7718 14.2284 18.0882 15.1827 18.6849C16.1369 19.2817 16.9042 20.1348 17.3969 21.1467",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62493 11.7719C5.05572 11.7717 4.49828 11.6097 4.01771 11.3046C3.53714 10.9996 3.15328 10.5641 2.91095 10.0491C2.66861 9.534 2.57781 8.96063 2.64914 8.39591C2.72047 7.83118 2.95099 7.2984 3.31378 6.85978C3.67658 6.42116 4.15667 6.09481 4.698 5.91883C5.23932 5.74284 5.81955 5.7245 6.37091 5.86593C6.92227 6.00737 7.42202 6.30274 7.8118 6.71757C8.20157 7.13239 8.46529 7.64955 8.57215 8.20864",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4277 8.20871C15.5345 7.64953 15.7982 7.13228 16.188 6.71736C16.5778 6.30245 17.0775 6.00699 17.629 5.8655C18.1804 5.72401 18.7607 5.74233 19.3021 5.91832C19.8435 6.0943 20.3237 6.42069 20.6865 6.85936C21.0494 7.29804 21.2799 7.83089 21.3512 8.3957C21.4226 8.9605 21.3317 9.53394 21.0894 10.0491C20.847 10.5642 20.463 10.9997 19.9824 11.3047C19.5017 11.6098 18.9442 11.7718 18.3749 11.7719",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleMapping);
export default __webpack_public_path__ + "static/media/roleMapping.986de3efacb0e56c4a18ee2df525425b.svg";
export { ForwardRef as ReactComponent };